import { render, staticRenderFns } from "./SecondaryCommissionList.vue?vue&type=template&id=3db78eb6&scoped=true"
import script from "./SecondaryCommissionList.vue?vue&type=script&lang=js"
export * from "./SecondaryCommissionList.vue?vue&type=script&lang=js"
import style0 from "./SecondaryCommissionList.vue?vue&type=style&index=0&id=3db78eb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db78eb6",
  null
  
)

export default component.exports